import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { Component, Inject, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Params } from '@angular/router';
import { UMPCategory, Utils } from '../../../../../utils/utils';
import { SpinnerOverlayService } from '../../../../../services/spinner-overlay.service';
import { SaveService } from '../../../../../services/save.service';
import { DefaultValuesService } from '../../../../../services/defaultvalues.service';

interface CDPHierarchyNode {
    selected?: boolean;
    disabled?: boolean;
    indeterminate?: boolean;
    parent?: CDPHierarchyNode;

    groupId: string;
    groupName: string;
    subGroupsAllowed: boolean;
    groups: CDPHierarchyNode[];
}

@Component({
    selector: 'cdphierarchy',
    templateUrl: './cdphierarchy.component.html',
    styleUrls: ['./cdphierarchy.component.less', '../../../../../style/new-generic-styles.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class CDPHierarchyComponent implements OnInit {
    @Input() public groupmgmtcallback: Function | undefined;
    selectorValue: string = 'All';
    allToggelButtonOption = [];

    userId: string = '';
    public TREE_DATA: CDPHierarchyNode[] = [];

    public selectedNodes: string[] = [];
    public unselectedNodes: string[] = [];

    public treeControl: NestedTreeControl<CDPHierarchyNode>;
    public dataSource = new MatTreeNestedDataSource<CDPHierarchyNode>();

    public searchString: string = '';
    public showOnlySelected: boolean = false;
    Tree_Response_State: number = -2; //0 -> empty , 1 -> correct and not empty ,-1 -> error, -2 -> Calling API
    showData: boolean = false;

    isCallSucceed: number = 0;

    public accessControlList: CDPHierarchyAccessControl[] = [];
    data: TreeManagement<UMPCategory> = {
        SelectedBranches: [],
        UnselectedBranches: [],
        UmpCategory: UMPCategory.CDPHierarchy
    };

    constructor(
        private toastrService: ToastrService,
        private route: ActivatedRoute,
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private spinnerOverlayService: SpinnerOverlayService,
        private saveService: SaveService,
        private defaults: DefaultValuesService
    ) {
        this.route.params.subscribe(
            (params: Params) => {
                this.hideData();
            });
        this.treeControl = new NestedTreeControl<CDPHierarchyNode>((node) => node.groups);
    }

    ngOnInit() {
        this.accessControlList = [
            { adminAccess: this.defaults.isadminuser}
        ]
    }

    resetAll() {
        this.treeControl = new NestedTreeControl<CDPHierarchyNode>((node) => node.groups);
        this.dataSource = new MatTreeNestedDataSource<CDPHierarchyNode>();
        this.userId = this.route.snapshot.paramMap.get('userId') || '';
        this.showData = true;
        this.allToggelButtonOption = [];
        this.funcGetUserCDPGroups();
    }

    funcGetUserCDPGroups() {
        this.Tree_Response_State = -2;
        this.treeControl.dataNodes = [];
        this.TREE_DATA.splice(0, this.TREE_DATA.length)
        Utils.httpGetUserCDPGroups(
            this.http,
            this.baseUrl,
            this.userId,
            this,
            (tthis: CDPHierarchyComponent, data: any) => {
                tthis.TREE_DATA = data.treeView;
                tthis.treeControl.dataNodes = tthis.TREE_DATA;
                tthis.dataSource.data = tthis.TREE_DATA;
                tthis.selectedNodes = data.excludedPersonae;
                Object.keys(tthis.dataSource.data).forEach((key) => {
                    tthis.setParent(tthis.dataSource.data[key], undefined);
                });
                tthis.preselect();
            }
        );
    }

    funcNotify() {
        if (this.isCallSucceed === 1) {
            this.toastrService.success('Update CDP Hierarchy request sent successfully !', 'Update CDP Hierarchy Request!');
        }
        else if (this.isCallSucceed === -1) {
            this.toastrService.error('Update CDP Hierarchy request not sent successfully !', 'Update CDP Hierarchy Request!');
        }
    }

    isEditAllowed(): boolean {
        return this.defaults.isadminuser;
    }

    public itemToggle(checked: boolean, node: CDPHierarchyNode, manualUpdate: boolean = false) {
        if (manualUpdate) {
            this.saveService.addListener(this);
            this.saveService.showSaveButton();
        }

        node.selected = checked;
        if (node.groups && checked) {
            node.indeterminate = false;
            this.itemUnselect(node);
        }

        if (node.groups) {
            this.itemDisable(checked, node);
        }

        if (manualUpdate) {
            if (checked) {
                this.data.UnselectedBranches = this.data.UnselectedBranches.filter(e => e !== node.groupId);
                if (this.unselectedNodes.find(e => e === node.groupId)) {
                    this.data.SelectedBranches.push(node.groupId);
                }
            }
            else {
                this.data.SelectedBranches = this.data.SelectedBranches.filter(e => e !== node.groupId);
                if (this.selectedNodes.find(e => e === node.groupId)) {
                    this.data.UnselectedBranches.push(node.groupId);
                }
            }
        }

        this.checkAllParents(node);
    }

    public hasChild = (_: number, node: CDPHierarchyNode) =>
        !!node.groups && node.groups.length > 0;

    public onSave() {
        if (this.data.SelectedBranches.length > 0 || this.data.UnselectedBranches.length > 0) {
            this.spinnerOverlayService.setFalseskipInterceptor();
            Utils.httpPostTreeGroupsByType(
                this.http,
                this.baseUrl,
                this.data,
                this.userId,
                this,
                function (tthis: CDPHierarchyComponent, data: any) {
                    tthis.data.SelectedBranches = [];
                    tthis.data.UnselectedBranches = [];
                    tthis.spinnerOverlayService.setTrueskipInterceptor();
                    tthis.funcNotify();
                    tthis.funcGetUserCDPGroups();
                    if (tthis.groupmgmtcallback) {
                        tthis.groupmgmtcallback(data);
                    }
                }
            );
        }
    }

    public hideLeafNode(node: CDPHierarchyNode) {
        return new RegExp(this.searchString, 'i').test(node.groupName) === false;
    }

    public hideParentNode(node: CDPHierarchyNode): boolean {
        if (
            !this.searchString
            || node.groupName.toLowerCase().indexOf(this.searchString.toLowerCase()) !== -1
        ) {
            return false; // Show the node if search string matches
        }

        const descendants = this.treeControl.getDescendants(node);
        if (
            descendants.some(
                descendant =>
                    descendant.groupName.toLowerCase().indexOf(this.searchString.toLowerCase()) !== -1
            ) 
        ){
            return false; // Show the parent if any descendant matches the search string
        }

        return true; // Hide the node if neither it nor its descendants match the search string
    }

    public hideData() {
        this.showData = false;
        this.TREE_DATA = [];
        this.treeControl.dataNodes = [];
        this.dataSource.data = [];
        this.selectedNodes = [];
    }

    private setParent(node: CDPHierarchyNode, parent: CDPHierarchyNode | undefined) {
        if (node) {
            node.parent = parent;
        }
        if (node.groups) {
            node.groups.forEach((child) => {
                this.setParent(child, node);
            });
        }
    }

    /**
    * Iterates through all nodes and their descendants in the tree,
    * automatically toggling selection for nodes whose groupId exists in the selectedNodes array.
    * Unselected nodes' groupIds are collected in the unselectedNodes array.
    */
    private preselect() {
        this.unselectedNodes = [] as string[];

        for (let i = 0; i < this.treeControl.dataNodes.length; i++) {
            if (this.selectedNodes.find(e => e === this.treeControl.dataNodes[i].groupId)) {
                this.itemToggle(true, this.treeControl.dataNodes[i])
            }
            else {
                this.unselectedNodes.push(this.treeControl.dataNodes[i].groupId);
            }

            if (this.treeControl.dataNodes[i].groups) {
                const alldescendants = this.treeControl.getDescendants(this.treeControl.dataNodes[i]);

                for (let j = 0; j < alldescendants.length; j++) {
                    if (this.selectedNodes.find(e => e === alldescendants[j].groupId)) {
                        this.itemToggle(true, alldescendants[j]);
                    }
                    else {
                        this.unselectedNodes.push(alldescendants[j].groupId);
                    }
                }
            }
        }
    }

    private itemUnselect(node: CDPHierarchyNode) {
        const descendants = this.treeControl.getDescendants(node);
        descendants.forEach((descendant) => {
            descendant.selected ? this.data.SelectedBranches.push(node.groupId) : null;
            descendant.indeterminate = false;
            descendant.selected = false;
        });
    }

    private itemDisable(checked: boolean, node: CDPHierarchyNode) {
        const descendants = this.treeControl.getDescendants(node);
        descendants.forEach(descendant => descendant.disabled = checked);
    }

    private checkAllParents(node: CDPHierarchyNode) {
        if (node.parent) {
            const descendants = this.treeControl.getDescendants(node.parent);
            node.parent.indeterminate = descendants.some(child => child.selected);
            this.checkAllParents(node.parent);
        }
    }
}